import styled from "styled-components"

export const Container = styled.div `
    background-color: #fff;
    box-shadow: 0px 0px 5px #CCC;
    padding: 20px;
    border-radius: 10px;
    margin-top: -40px;
    display: flex;
    align-items: center;
`

export const MonthArea = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
`

export const MonthArrow = styled.div`
    width: 40px;
    text-align: center;
    font-size: 25px;
    cursor: pointer;
`

export const MonthTitle = styled.div`
    flex: 1;
    text-align: center;
`

export const ResumeArea = styled.div`
    flex: 2;
    display: flex;
`